export default {"src":"/_next/static/media/rocket.4863c443.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};